import { render, staticRenderFns } from "./ClientManage.vue?vue&type=template&id=5456e6fb&"
import script from "./ClientManage.vue?vue&type=script&lang=js&"
export * from "./ClientManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports